import { render, staticRenderFns } from "./DataListStaffs.vue?vue&type=template&id=94d5bb04&"
import script from "./DataListStaffs.vue?vue&type=script&lang=js&"
export * from "./DataListStaffs.vue?vue&type=script&lang=js&"
import style0 from "./DataListStaffs.vue?vue&type=style&index=0&id=94d5bb04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports